export default [
  { text: 'Action', value: 'userAction' },
  { text: 'Taken By', value: 'userName' },
  { text: 'CreatedAt', value: 'createdAt' }
];
